import { format, parse, formatDistanceStrict, addHours } from 'date-fns';

export const formatDate = (date) => {
	if (date == null || date === '') return '';
	const d = new Date(date);
	if (isNaN(d.getTime())) return '';
	return format(convertToUTC(date), 'dd-MMM-yyyy');
};
export const formatDateTime = (date) => {
	if (date == null || date === '') return '';
	const d = new Date(date);
	if (isNaN(d.getTime())) return '';
	return format(convertToUTC(date), "dd-MMM-yyyy, HH:mm:ss");
};
export const parseDate = (date = '') => parse(date);

export const getTimeDifferenceText = (start, end) => {
	return formatDistanceStrict(start, end);
};

// Convert current time zone to UTC timezone
const convertToUTC = (date) => addHours(new Date(date), new Date(date).getTimezoneOffset() / 60);

export const getTimeSince = (date) => {
	const diff = convertToUTC(new Date()) - convertToUTC(date);
	const days = Math.floor(diff / 1000 / 60 / (60 * 24));
	if (days > 29) return days + ' days';
	else {
		return getTimeDifferenceText(convertToUTC(date), convertToUTC(new Date()));
	}
};
